import { VehicleViewModel } from '@ail/contracts-api'
import { useMemo } from 'react'
import { vehicleNatureValuesDict } from '../../../types/constants'

const InstallationIcons: Record<string, string | undefined> = {
  '0001': 'icon-inEmptyTop',
  '0010': 'icon-inRight',
  '0011': 'icon-inRightTop',
  '0100': 'icon-inCenter',
  '0101': 'icon-inCenterTop',
  '0110': 'icon-inRightCenter',
  '0111': 'icon-inRightCenterTop',
  '1000': 'icon-inLeft',
  '1001': 'icon-inLeftTop',
  '1010': 'icon-inLeftRight',
  '1011': 'icon-inLeftRightTop',
  '1100': 'icon-inLeftCenter',
  '1101': 'icon-inLeftCenterTop',
  '1110': 'icon-inAll',
  '1111': 'icon-inAllTop',
}

export function VehicleWrappingDetails(props: { vehicle?: VehicleViewModel }) {
  const installations = useMemo(() => {
    if (!props.vehicle) {
      return undefined
    }
    const { InteriorLeft, InteriorCenter, InteriorRight, ExteriorTop, ExteriorBack, Wrapping } = props.vehicle

    const left = typeof InteriorLeft === 'string' && InteriorLeft !== 'None' ? InteriorLeft : ''
    const center = typeof InteriorCenter === 'string' && InteriorCenter !== 'None' ? InteriorCenter : ''
    const right = typeof InteriorRight === 'string' && InteriorRight !== 'None' ? InteriorRight : ''
    const top = typeof ExteriorTop === 'string' && ExteriorTop !== 'None' ? ExteriorTop : ''
    const back = typeof ExteriorBack === 'string' && ExteriorBack !== 'None' ? ExteriorBack : ''
    const wrapping = typeof Wrapping === 'string' && Wrapping !== 'None' ? Wrapping : ''

    const mask = `${+!!left}${+!!center}${+!!right}${+!!top}`

    return { left, center, right, top, back, wrapping, mask, icon: InstallationIcons[mask] }
  }, [props.vehicle])

  const show = !!installations && (installations.mask !== '0000' || !!installations.back || !!installations.wrapping)

  return (
    show && (
      <div className="detailContentArea carOutfit">
        <div className="detailTitle eyeOk">
          <i className="icon-car-outfit" /> <span>Car Outfitting</span>
        </div>
        <div className="details">
          <div className="row">
            {!!installations?.wrapping && (
              <div className="col-6">
                <i
                  className={vehicleNatureValuesDict[props.vehicle?.nature as keyof typeof vehicleNatureValuesDict]}
                ></i>
                <label>{installations.wrapping}</label>
              </div>
            )}
            {!!installations && installations.mask !== '0000' && (
              <div className="col-6 interiorTooltip">
                <span className="tooltipText">
                  {!!installations.left && <>{`Left: ${installations.left}`}</>}
                  {!!installations.right && (
                    <>
                      <br />
                      {`Right: ${installations.right}`}
                    </>
                  )}
                  {!!installations.center && (
                    <>
                      <br />
                      {`Center: ${installations.center}`}
                    </>
                  )}
                  {!!installations.top && (
                    <>
                      <br />
                      {`Top: ${installations.top}`}
                    </>
                  )}
                  {!!installations.back && (
                    <>
                      <br />
                      {`Back: ${installations.back}`}
                    </>
                  )}
                </span>
                <i className={installations?.icon} />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  )
}
